import React from "react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { HeaderComponent } from "../../../components/HeaderComponent/HeaderComponent";
import { FooterComponent } from "../../../components/FooterComponent/FooterComponent";
import { ContentContainer } from "../../../components/_shared-components/arrangement/Container";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { HeaderSpacer } from "../../_layout-helpers/spacers";
import { DealerPageData, ExtractSwarovskiPageData } from "@swo/storefront";
import { DealerDetailsComponent } from "../../../components/DealerLocatorDetailsComponent/dealer-details-component";
import { useStore } from "../../../store/hooks/use-store";
import { getSwarovskiOptikHeadTitle } from "../../_layout-helpers/head-title";

export const DealerPageLayout: ReactTFC<ExtractSwarovskiPageData<DealerPageData>> = props => {
  const { googleApi } = useStore().state.config;

  return (
    <>
      <title>{getSwarovskiOptikHeadTitle(props.data.dealerDetails.name)}</title>

      <HeaderComponent header={props.data.header} version={"normal"} />
      <HeaderSpacer />

      <ContentContainer className={"expand"}>
        <DealerDetailsComponent
          dealerDetails={props.data.dealerDetails}
          translations={props.data.translations}
          generalTranslations={props.generalTranslations}
          dealerLocatorLink={props.data.dealerLocatorLink}
          apiKey={googleApi.key}
        />
      </ContentContainer>

      <Spacer size={"md"} />

      <FooterComponent {...props.data.footer} />
    </>
  );
};
